/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/TrimPath.ts
 * @create:      2025-07-01 17:59:22.795
 * @modify:      2025-07-11 21:19:12.959
 * @version:     6.0.0
 * @times:       5
 * @lines:       55
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { Strings_Slash, Strings_BackSlash } from "../const/Strings";

/**
 * Removes trailing slashes (`/` and `\`) from the given path string.
 * 
 * @param pathStr - The path string from which trailing slashes need to be removed.
 * @returns The path string with trailing slashes removed. If the input string is falsy, it returns the original string.
 * 
 * @since 4.0.0
 * @version 2025-07-03
 */
export function TrimPath(pathStr: string) {
    if (!pathStr) {
        return pathStr;
    }

    while (pathStr.length > 1 && (pathStr.endsWith(Strings_Slash) || pathStr.endsWith(Strings_BackSlash))) {
        pathStr = pathStr.substring(0, pathStr.length - 1);
    }

    return pathStr;
}
